import { render, staticRenderFns } from "./RoleAccessIndex.vue?vue&type=template&id=3dac98de&scoped=true&"
import script from "./RoleAccessIndex.vue?vue&type=script&lang=js&"
export * from "./RoleAccessIndex.vue?vue&type=script&lang=js&"
import style0 from "./RoleAccessIndex.vue?vue&type=style&index=0&id=3dac98de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac98de",
  null
  
)

export default component.exports